import { Injectable } from '@angular/core';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { FreeServicesParcelSearchFormControlName } from './fsp-parcel-search-form.model';
import {
  FormFieldOrientation,
  FormFieldType,
  FormFieldWrappers,
} from '../../../gk-kendo';

@Injectable({
  providedIn: 'root',
})
export class FspParcelSearchFormService {
  getFormConfig(): {
    fields: FormlyFieldConfig[];
    options?: FormlyFormOptions;
  } {
    return {
      fields: [
        {
          wrappers: [FormFieldWrappers.FormField],
          props: {
            label: 'Numer działki',
            orientation: FormFieldOrientation.Horizontal,
          },
          fieldGroupClassName: 'd-flex flex-row column-gap-1',
          fieldGroup: [
            {
              key: FreeServicesParcelSearchFormControlName.MainNumber,
              type: FormFieldType.KendoInput,
            },
            {
              template: `<span>/</span>`,
              className: 'mt-1',
            },
            {
              key: FreeServicesParcelSearchFormControlName.SubNumber,
              type: FormFieldType.KendoInput,
            },
          ],
        },
        {
          wrappers: [FormFieldWrappers.FormField],
          key: FreeServicesParcelSearchFormControlName.Address,
          type: FormFieldType.KendoInput,
          props: {
            label: 'FREE_PORTAL_SERVICES.ADDRESS',
          },
        },
        {
          type: '#communities',
          key: FreeServicesParcelSearchFormControlName.Community,
        },
        {
          type: '#districts',
          key: FreeServicesParcelSearchFormControlName.District,
        },
        {
          wrappers: [FormFieldWrappers.FormField],
          key: FreeServicesParcelSearchFormControlName.Owner,
          type: FormFieldType.KendoInput,
          props: {
            label: 'FREE_PORTAL_SERVICES.OWNER',
          },
        },
        {
          wrappers: [FormFieldWrappers.FormField],
          key: FreeServicesParcelSearchFormControlName.Pesel,
          type: FormFieldType.KendoInput,
          props: {
            label: 'FREE_PORTAL_SERVICES.PESEL',
          },
        },
        {
          wrappers: [FormFieldWrappers.FormField],
          key: FreeServicesParcelSearchFormControlName.RegisterUnit,
          type: FormFieldType.KendoInput,
          props: {
            label: 'FREE_PORTAL_SERVICES.REGISTER_UNIT',
          },
        },
      ],
    };
  }
}
